import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-forms',
  templateUrl: './turns-forms.component.html',
  styleUrls: ['./turns-forms.component.scss']
})
export class TurnsFormsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
